import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import SaveIcon from "@material-ui/icons/SaveAlt";

const DocumentsTabModal = ({
                               yesOption,
                               noOption,
                               onDownloadDocumentsHandler,
                               doc
                           }) => {
    const [openModal, setOpenModal] = React.useState(false);
    const [openProtocolModal, setOpenProtocolModal] = React.useState(false);

    const onDocumentListItemClick = (doc) => {
        if (doc.zapytanie) {
            setOpenModal(true)
        } else {
            if (doc.dokument === "Protokół wydania") {
                setOpenProtocolModal(true);
            } else {
                onDownloadDocumentsHandler();
            }
        }
    };

    return (
        <React.Fragment>
            <Dialog open={openModal}>
                <DialogContent>
                    Czy bieżącą datę i godzinę ustawić jako zakończenie wynajmu?
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => {
                        yesOption();
                        setOpenModal(false)
                    }}>Tak</Button>
                    <Button
                        onClick={() => {
                            noOption();
                            setOpenModal(false)
                        }}
                    >
                        Nie
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openProtocolModal}>
                <DialogContent>
                    Wydruk protokołu wydania potwierdza utworzenie wynajmu. Czy kontynuować?
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => {
                        onDownloadDocumentsHandler();
                        setOpenProtocolModal(false)
                    }}>Tak</Button>
                    <Button
                        onClick={() => {
                            setOpenProtocolModal(false)
                        }}
                    >
                        Nie
                    </Button>
                </DialogActions>
            </Dialog>


            <ListItem
                onClick={() => onDocumentListItemClick(doc)}
                dense
                button
            >
                <ListItemIcon>
                    <SaveIcon/>
                </ListItemIcon>
                <ListItemText primary={doc.dokument}/>
            </ListItem>
        </React.Fragment>
    );
};

export default DocumentsTabModal
